<div class="live-new" [class.live-new--with-panel]="selectedDevice">
  <!-- Top action bar -->
  <header class="ln-topbar">
    <div class="ln-topbar__title-block">
      <h1 class="ln-topbar__title">Live</h1>
      <div class="ln-topbar__subtitle">
        <span class="ln-status-dot ln-status-dot--green"></span>
        <span>{{ lastPolledLabel }}</span>
      </div>
    </div>

    <div class="ln-topbar__actions">
      <button
        type="button"
        class="ln-btn"
        [class.ln-btn--green]="statusCount.communicating > 0"
        [class.ln-btn--gray]="statusCount.communicating === 0"
        [class.ln-btn--active-communicating]="selectedCommunicationFilter === 'communicating'"
        ngbTooltip="Data received within the last 24 hours."
        placement='bottom'
        tooltipClass="ln-tooltip"
        [disabled]="statusCount.communicating === 0"
        (click)="selectCommunicationFilter('communicating')"
      >
        <i class="fa fa-signal" aria-hidden="true"></i>
        <span>Communicating</span>
        <span
          class="ln-topbar__actions-count"
          [class.ln-topbar__actions-count--green]="statusCount.communicating > 0"
          [class.ln-topbar__actions-count--gray]="statusCount.communicating === 0"
        >{{ statusCount.communicating }}</span>
      </button>
      <button
        type="button"
        class="ln-btn"
        [class.ln-btn--yellow]="notCommunicatingCount > 0"
        [class.ln-btn--gray]="notCommunicatingCount === 0"
        [class.ln-btn--active-notCommunicating]="selectedCommunicationFilter === 'notCommunicating'"
        ngbTooltip="No data received within the last 24 hours."
        placement='bottom'
        tooltipClass="ln-tooltip"
        [disabled]="notCommunicatingCount === 0"
        (click)="selectCommunicationFilter('notCommunicating')"
      >
        <i class="fa fa-triangle-exclamation" aria-hidden="true"></i>
        <span>Not Communicating</span>
        <span
          class="ln-topbar__actions-count"
          [class.ln-topbar__actions-count--yellow]="notCommunicatingCount > 0"
          [class.ln-topbar__actions-count--gray]="notCommunicatingCount === 0"
        >{{ notCommunicatingCount }}</span>
      </button>
      <button
        type="button"
        class="ln-btn"
        [class.ln-btn--red]="statusCount.disconnected > 0"
        [class.ln-btn--gray]="statusCount.disconnected === 0"
        [class.ln-btn--active-disconnected]="selectedCommunicationFilter === 'disconnected'"
        ngbTooltip="Devices that have been disconnected from the vehicle."
        placement='bottom'
        tooltipClass="ln-tooltip"
        [disabled]="statusCount.disconnected === 0"
        (click)="selectCommunicationFilter('disconnected')"
      >
        <i class="fa fa-link-slash" aria-hidden="true"></i>
        <span>Disconnected</span>
        <span
          class="ln-topbar__actions-count"
          [class.ln-topbar__actions-count--red]="statusCount.disconnected > 0"
          [class.ln-topbar__actions-count--gray]="statusCount.disconnected === 0"
        >{{ statusCount.disconnected }}</span>
      </button>
    </div>

    <div class="ln-topbar__actions">
      <app-button-dropdown
        #customerDropdown
        leadIcon="fa fa-building-o"
        [options]="groupOptions"
        [selectedValue]="selectedGroupId"
        (selectionChange)="selectGroups($event)"
        (menuOpen)="closeRefreshDropdown()"
        [searchable]="true"
        searchPlaceholder="Search customer name…"
        menuMaxHeight="260px"
      ></app-button-dropdown>
      <div class="ln-dropdown ln-dropdown--refresh">
        <button
          type="button"
          class="ln-dropdown__btn"
          (click)="toggleRefreshDropdown()"
        >
          <i class="fa fa-refresh ln-dropdown__lead-icon ln-dropdown__lead-icon--green" aria-hidden="true"></i>
          <span class="ln-dropdown__label">Auto Refresh: {{ selectedRefresh.label }}</span>
          <i class="fa fa-chevron-down ln-dropdown__chevron" aria-hidden="true"></i>
        </button>
        @if (refreshDropdownOpen) {
          <ul class="ln-dropdown__menu ln-dropdown__menu--right">
            @for (option of refreshOptions; track option.value) {
              <li
                class="ln-dropdown__item"
                [class.ln-dropdown__item--active]="option.value === selectedRefresh.value"
                (click)="selectRefresh(option)"
              >
                {{ option.label }}
              </li>
            }
          </ul>
        }
      </div>

      <button type="button" class="ln-btn ln-btn--ghost" (click)="refreshNow()">
        <i class="fa fa-refresh" aria-hidden="true"></i>
        <span>Refresh</span>
      </button>
    </div>
  </header>

  <!-- Main grid -->
  <div class="ln-body">
    <!-- Left: Live Devices list -->
    <aside class="ln-devices">
      <div class="ln-devices__head">
        <h2 class="ln-devices__title">Live Devices</h2>
        <span class="ln-devices__count">{{ activeMapDevices.length }}</span>
      </div>

      <div class="ln-devices__search">
        <i class="fa fa-search ln-devices__search-icon" aria-hidden="true"></i>
        <input
          type="search"
          class="ln-devices__search-input"
          placeholder="Search by Asset Name or VIN"
          [(ngModel)]="searchQuery"
          (input)="drawMarkers()"
        />
      </div>

      <ul class="ln-devices__list" #devicesList>
        @for (d of activeMapDevices; track trackById(d, $index)) {
          <li
            class="ln-device"
            [class.ln-device--selected]="isSelected(d)"
            (click)="selectDevice(d)"
            (keydown.enter)="selectDevice(d)"
            tabindex="0"
            role="button"
            [attr.aria-label]="'Open device ' + d.id"
          >
            <span class="ln-device__status-dot" [ngClass]="statusDotClass(d.status)"></span>

            <div class="ln-device__body">
              <div class="ln-device__id-row">
                <span class="ln-device__id">
                  <button
                    type="button"
                    class="ln-device__name-link"
                    title="Trip Dashboard"
                    (click)="goToTripDashboard($event, d)">
                    {{ d.id }}
                  </button>
                  <button
                    type="button"
                    class="ln-device__copy-btn"
                    title="Copy Serial Number"
                    (click)="copySerialNumber($event, d.id)">
                    <i class="fa-regular fa-copy" aria-hidden="true"></i>
                  </button>
                </span>
                <span class="ln-device__vehicle" [ngClass]="vehicleIconClass(d.vehicleColor)">
                  <i class="fa fa-car" style="font-size: 0.85rem; color:currentColor" aria-hidden="true"></i>
                </span>
              </div>

              <div class="ln-device__meta-row">
                <span class="ln-device__event">
                  <i class="fa" [ngClass]="{
                    'fa-tower-broadcast': d.lastEventIcon === 'broadcast',
                    'fa-play-circle': d.lastEventIcon === 'play',
                    'fa-clock-o': d.lastEventIcon === 'clock',
                    'fa-key': d.lastEventIcon === 'key',
                    'fa-chain-broken': d.lastEventIcon === 'unlink',
                    'fa-flag-checkered': d.lastEventIcon === 'flag',
                    'fa-location-dot': d.lastEventIcon === 'location-dot',
                    'fa-battery-full': d.lastEventIcon === 'battery-full',
                    'fa-plug': d.lastEventIcon === 'plug',
                  }" aria-hidden="true"></i>
                  <span>{{ d.lastEvent }}</span>
                </span>
                <span class="ln-device__time">{{ d.timeAgo }}</span>
              </div>
            </div>
          </li>
        }
      </ul>

      <div class="ln-devices__footer">
        <span class="ln-devices__footer-text">
          1 - {{ activeMapDevices.length }} of {{ activeMapDevices.length }}
        </span>
        <!-- <button type="button" class="ln-btn ln-btn--ghost ln-btn--sm" (click)="loadMore()">
          <span>Load More</span>
          <i class="fa fa-arrow-down" aria-hidden="true"></i>
        </button> -->
      </div>
    </aside>

    <!-- Center: Map area -->
    <section class="ln-map">
      <!-- Map toolbar filters hidden (Group By + Trip Status)
      <div class="ln-map__toolbar">
        <div class="ln-dropdown ln-dropdown--compact">
          <span class="ln-dropdown__pre-label">Group By</span>
          <button
            type="button"
            class="ln-dropdown__btn ln-dropdown__btn--map"
            (click)="toggleGroupByDropdown()"
          >
            <span class="ln-dropdown__label">{{ selectedGroupBy }}</span>
            <i class="fa fa-chevron-down ln-dropdown__chevron" aria-hidden="true"></i>
          </button>
          @if (groupByDropdownOpen) {
            <ul class="ln-dropdown__menu">
              @for (option of groupByOptions; track option) {
                <li
                  class="ln-dropdown__item"
                  [class.ln-dropdown__item--active]="option === selectedGroupBy"
                  (click)="selectGroupBy(option)"
                >
                  {{ option }}
                </li>
              }
            </ul>
          }
        </div>

        <div class="ln-dropdown ln-dropdown--compact">
          <button
            type="button"
            class="ln-dropdown__btn ln-dropdown__btn--map"
            (click)="toggleStatusFilterDropdown()"
          >
            <i class="fa fa-car ln-dropdown__lead-icon" aria-hidden="true"></i>
            <span class="ln-dropdown__label">{{ selectedStatusFilter }}</span>
            <i class="fa fa-chevron-down ln-dropdown__chevron" aria-hidden="true"></i>
          </button>
          @if (statusFilterDropdownOpen) {
            <ul class="ln-dropdown__menu">
              @for (option of statusFilterOptions; track option) {
                <li
                  class="ln-dropdown__item"
                  [class.ln-dropdown__item--active]="option === selectedStatusFilter"
                  (click)="selectStatusFilter(option)"
                >
                  {{ option }}
                </li>
              }
            </ul>
          }
        </div>
      </div>
      -->

      <div class="ln-map__canvas" #mapCanvas></div>

      <div class="ln-map__controls">
        <button type="button" class="ln-map__ctrl" aria-label="Recenter" (click)="recenterMap()">
          <i class="fa fa-crosshairs" aria-hidden="true"></i>
        </button>
        <div class="ln-map__zoom">
          <button type="button" class="ln-map__ctrl" aria-label="Zoom in" (click)="zoomIn()">
            <i class="fa fa-plus" aria-hidden="true"></i>
          </button>
          <div class="ln-map__ctrl-divider"></div>
          <button type="button" class="ln-map__ctrl" aria-label="Zoom out" (click)="zoomOut()">
            <i class="fa fa-minus" aria-hidden="true"></i>
          </button>
        </div>
        <button type="button" class="ln-map__ctrl" aria-label="Fullscreen" (click)="toggleFullscreen()">
          <i class="fa fa-expand" aria-hidden="true"></i>
        </button>
      </div>

      <div class="ln-map__type-toggle">
        <button type="button" class="ln-map__type-btn"
          [class.ln-map__type-btn--active]="currentMapType === 'roadmap'"
          (click)="setMapType('roadmap')">
          Map
        </button>
        <button  type="button"  class="ln-map__type-btn"
          [class.ln-map__type-btn--active]="currentMapType === 'hybrid'"
          (click)="setMapType('hybrid')">
          Satellite
        </button>
      </div>
    </section>

    <!-- Right: Selected device details (only when a device is selected) -->
    @if (selectedDevice) {
      <aside class="ln-details" aria-label="Device details">
        <button
          type="button"
          class="ln-details__close"
          (click)="closeDetailsPanel()"
          aria-label="Close details"
        >
          <i class="fa fa-times" aria-hidden="true"></i>
        </button>

        <div class="ln-details__head">
          <div class="ln-details__avatar" [ngClass]="{
            'ln-details__avatar--green': selectedDevice.vehicleColor === 'green',
            'ln-details__avatar--orange': selectedDevice.vehicleColor === 'orange',
            'ln-details__avatar--red': selectedDevice.vehicleColor === 'red',
          }">
            <i class="fa fa-car" style="font-size: 1.25rem;" aria-hidden="true"></i>
          </div>
          <div class="ln-details__title-block">
            <h2 class="ln-details__id">{{ selectedDevice.id }}</h2>
            <div class="ln-details__flags">
              <span class="ln-flag">
                <span class="ln-status-dot ln-status-dot--{{ selectedDevice.vehicleColor }}"></span>
                {{ selectedDevice.vehicleColor === 'red'
                    ? 'Disconnected'
                    : (selectedDevice.vehicleColor === 'green' ? 'Communicating' : 'Not Communicating') }}
              </span>
              <!-- <div class="ln-flag">
                <span class="ln-device-status__value">
                  <span
                    class="ln-status-dot"
                    [ngClass]="selectedDevice.gpsStatus === 'Available' ? 'ln-status-dot--green' : 'ln-status-dot--red'"
                  ></span>
                </span>
                <span class="ln-flag"> GPS {{ selectedDevice.gpsStatus }}</span>
              </div> -->
              <!-- <span class="ln-flag">
                <span
                  class="ln-status-dot"
                  [ngClass]="selectedDevice.online ? 'ln-status-dot--green' : 'ln-status-dot--red'"
                ></span>
                {{ selectedDevice.online ? 'Online' : 'Offline' }}
              </span> -->
            </div>
          </div>
        </div>

        <hr />

        <section class="ln-details__section">
          <h3 class="ln-details__section-title">Last Known Location</h3>
          <div class="ln-details__row">
            <i class="fa fa-map-marker ln-details__row-icon" aria-hidden="true"></i>
            <span class="ln-details__row-text">{{ selectedDevice.lastKnownLocation }}</span>
          </div>
          <div class="ln-details__row">
            <i class="fa fa-calendar-o ln-details__row-icon" aria-hidden="true"></i>
            <span class="ln-details__row-text">{{ selectedDevice.lastKnownEventDate }}</span>
            <span class="ln-details__row-trailing">{{ selectedDevice.timeAgo }}</span>
          </div>
        </section>

        <!-- <section class="ln-details__section">
          <h3 class="ln-details__section-title">Last Known Event</h3>
          <div class="ln-event-card">
            <div class="ln-event-card__head">
              <i class="fa" [ngClass]="{
                'fa-tower-broadcast': selectedDevice.lastEventIcon === 'broadcast',
                'fa-play-circle': selectedDevice.lastEventIcon === 'play',
                'fa-clock-o': selectedDevice.lastEventIcon === 'clock',
                'fa-key': selectedDevice.lastEventIcon === 'key',
                'fa-chain-broken': selectedDevice.lastEventIcon === 'unlink',
                'fa-flag-checkered': selectedDevice.lastEventIcon === 'flag'
              }" aria-hidden="true"></i>
              <span>{{ selectedDevice.lastEvent }}</span>
            </div>
            <div class="ln-event-card__meta">
              <span>{{ selectedDevice.lastKnownEventDate }}</span>
              <span>{{ selectedDevice.timeAgo }}</span>
            </div>
          </div>
        </section> -->

        <!-- <section class="ln-details__section">
          <h3 class="ln-details__section-title">Trip Status</h3>
          <div class="ln-trip-card">
            <div class="ln-trip-card__head">
              <span class="ln-trip-card__badge" [ngClass]="{
                'ln-trip-card__badge--green': selectedDevice.tripStatus === 'In Trip' || selectedDevice.tripStatus === 'Trip End',
                'ln-trip-card__badge--orange': selectedDevice.tripStatus === 'Idle',
                'ln-trip-card__badge--red': selectedDevice.tripStatus === 'Disconnected'
              }">
                {{ selectedDevice.tripStatus }}
              </span>
              <span class="ln-trip-card__since">Since {{ selectedDevice.tripSince }}</span>
            </div>
            <div class="ln-trip-card__metrics">
              <div class="ln-trip-metric">
                <span class="ln-trip-metric__label">Distance</span>
                <span class="ln-trip-metric__value">{{ selectedDevice.tripDistance }}</span>
              </div>
              <div class="ln-trip-metric">
                <span class="ln-trip-metric__label">Duration</span>
                <span class="ln-trip-metric__value">{{ selectedDevice.tripDuration }}</span>
              </div>
            </div>
          </div>
        </section> -->

        <section class="ln-details__section">
          <h3 class="ln-details__section-title">Vehicle Info</h3>
          <div class="ln-trip-card">
            <div class="ln-details__row">
              <span class="ln-details__row-text ln-details__row-text--label">VIN</span>
              <span class="ln-details__row-text ln-details__row-text--value">{{ selectedDevice.vin || '-' }}</span>
            </div>
            <hr class="ln-details__row-divider" />
            <div class="ln-details__row">
              <span class="ln-details__row-text ln-details__row-text--label">Make / Model</span>
              <span class="ln-details__row-text ln-details__row-text--value">{{ selectedDevice.make || '-' }} {{ selectedDevice.model }}</span>
            </div>
            <hr class="ln-details__row-divider" />
            <div class="ln-details__row">
              <span class="ln-details__row-text ln-details__row-text--label">Year</span>
              <span class="ln-details__row-text ln-details__row-text--value">{{ selectedDevice.year || '-' }}</span>
            </div>
          </div>
        </section>

        <!--<section class="ln-details__section">
          <h3 class="ln-details__section-title">Device Status</h3>
          <ul class="ln-device-status">
            <li class="ln-device-status__row">
              <span class="ln-device-status__label">Last Contact</span>
              <span class="ln-device-status__value">
                {{ selectedDevice.timeAgo }}
                <span class="ln-status-dot ln-status-dot--green"></span>
              </span>
            </li>
            <li class="ln-device-status__row">
              <span class="ln-device-status__label">GPS Status</span>
              <span class="ln-device-status__value">
                {{ selectedDevice.gpsStatus }}
                <span
                  class="ln-status-dot"
                  [ngClass]="selectedDevice.gpsStatus === 'Available' ? 'ln-status-dot--green' : 'ln-status-dot--red'"
                ></span>
              </span>
            </li>
             <li class="ln-device-status__row">
              <span class="ln-device-status__label">Communication</span>
              <span class="ln-device-status__value">
                {{ selectedDevice.communication }}
                <span
                  class="ln-status-dot"
                  [ngClass]="selectedDevice.communication === 'Online' ? 'ln-status-dot--green' : 'ln-status-dot--red'"
                ></span>
              </span>
            </li>
            <li class="ln-device-status__row">
              <span class="ln-device-status__label">Battery</span>
              <span class="ln-device-status__value">
                {{ selectedDevice.battery }}%
                <span class="ln-battery">
                  <span class="ln-battery__fill" [style.width.%]="selectedDevice.battery"></span>
                </span>
              </span>
            </li>
          </ul>
        </section> -->

        <section class="ln-details__section">
          <h3 class="ln-details__section-title">Quick Actions</h3>
          <div class="ln-quick-actions">
            <button type="button" class="ln-quick-action" (click)="viewDeviceDetails(selectedDevice?.deviceId ?? '')">
              <i class="fa fa-file-text-o" aria-hidden="true"></i>
              <span>View Device Details</span>
            </button>
            <button type="button" class="ln-quick-action" (click)="goToTripDashboard($event, selectedDevice)">
              <i class="fa fa-road" aria-hidden="true"></i>
              <span>Trip Dashboard</span>
            </button>
            <button type="button" class="ln-quick-action disabled">
              <i class="fa fa-stethoscope" aria-hidden="true"></i>
              <span>Run Diagnostics</span>
            </button>
          </div>
        </section>
      </aside>
    }
  </div>
</div>
